import IStampOutput from "@/api/models/IStampOutput";

export default function createProjectOutput(): IStampOutput {
  return {
    id: 0,
    width: "25",
    icon: "",
    image: null,
    height: "25",
    top: "0",
    left: "35",
    officeId: ""
  };
}
